<template>
  <div>
    <div class="columns">
      <div class="column is-one-half">
        <b-field label="Date Ordered" message=" ">
          <div v-if="editing">
            <b-datepicker
              ref="orderDate"
              placeholder="Select a date"
              icon="far fa-calendar"
              :readonly="false"
              required
              v-model="dateFormatted">
            </b-datepicker>
          </div>
          <div v-else>
            {{ formData.orderDate }}
          </div>
        </b-field>
      </div>
      <div class="column is-one-half">
        <div v-if="editing">
          <b-field  v-if="editing" label="Vendor Name" message="All new vendors must be submitted first to the Finance Department.">
            <b-autocomplete
              ref="vendorName"
              v-model="formData.vendorName"
              placeholder="Select a Vendor"
              :keep-first="keepFirst"
              :data="filteredVendorValueList"
              :open-on-focus="openOnFocus"
              @select="option => selected = option">
            </b-autocomplete>
          </b-field> 
        </div>
        <div v-else>
          <b-field label="Vendor Name">
          {{ formData.vendorName }}
          </b-field>
        </div>
      </div> 
    </div>
    <div class="columns">
      <div class="column is-one-half">
        <div v-if="editing">
          <b-field label="Sales Contact Name">
            <b-input v-model="salesContact.name"></b-input>
          </b-field>
        </div>
        <div v-else>
          <b-field label="Sales Contact Name">
           {{ salesContact.name }}
          </b-field>
        </div>
      </div>
      <div class="column is-one-half">
        <div v-if="editing">
          <b-field label="Email">
            <b-input v-model="salesContact.email"></b-input>
          </b-field>
        </div>
        <div v-else>
          <b-field label="Email">
           {{ salesContact.email }}
          </b-field>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-third">
        <div v-if="editing">
          <b-field label="Telephone #">
            <b-input v-model="salesContact.phone"></b-input>
          </b-field>
        </div>
        <div v-else>
          <b-field label="Telephone #">
           {{ salesContact.phone }}
          </b-field>
        </div>
      </div>
      <div class="column is-one-third">
        <div v-if="editing">
          <b-field label="Cell #">
            <b-input v-model="salesContact.cell"></b-input>
          </b-field>
        </div>
        <div v-else>
          <b-field label="Cell #">
           {{ salesContact.cell }}
          </b-field>
        </div>
      </div>
      <div class="column is-one-third">
        <div v-if="editing">
          <b-field label="Fax #">
            <b-input v-model="salesContact.fax"></b-input>
          </b-field>
        </div>
        <div v-else>
          <b-field label="Fax #">
           {{ salesContact.fax }}
          </b-field>
        </div>
      </div>
    </div>
    <b-field label="Notes">
        <b-input type="textarea" v-model=formData.notes :disabled="!editing"></b-input>
    </b-field>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PurchaseOrderForm',
  props: ['formData', 'editing', 'receiving', 'receivedAll', 'salesContact', 'vendorOptions'],
  data () {
    return {
      dateFormatted: new Date(),
      openOnFocus: true,
      keepFirst: true,
      vendorName: "",

    };
  },
  computed:{
    ...mapState([
      'userInfo',
      'departmentValueList',
      'vendorValueList',
      'purchasingAgentValueList',
      'salesContactLookup'
    ]),
    
    // Constructs the autocomplete Vendor value list as the user types
    filteredVendorValueList: function() {
        if( this.formData.vendorName == null){
          return this.vendorOptions;
        }
        if(this.vendorOptions){
          return this.vendorOptions.filter((option) => {
              return option
                  .toString()
                  .toLowerCase()
                  .indexOf(this.formData.vendorName.toLowerCase()) >= 0;
          });
        }
        else{
          return [];
        }
    },
 
  },
  created: function(){
    this.formData.orderDate = new Date().toLocaleDateString();
  },
  
  watch:{
    dateFormatted: function(){
      /**
      * FM Dates are not compatible with the buefy date picker so
      * to get it to work, we show a formatted field, and attach a trigger
      * to keep the date field in-sync.
      */
      this.formData.orderDate = this.dateFormatted.toLocaleDateString();
      
    },
    formData: {
     handler(newValue, oldValue) {
       this.lookupSalesContact();
     },
     deep: true
    }
  },
  methods:{
    setDate: function(dt){
      this.dateFormatted = dt;
    },
    validate: function(){
      if(this.editing == true){
        return this.$refs.orderDate.checkHtml5Validity();
      }
      return true;
    },
    validateVendor: function(){
      self = this;
      if(self.formData.vendorName && self.editing){
        // when active vendor change was made, could no longer
        // validate inactive vendors on existing POs
        var validVendor = this.vendorOptions.some(function(vendor){
          return vendor.toLowerCase() == self.formData.vendorName.toLowerCase();
        });
      }
      else if(self.formData.vendorName && !self.editing){
          return true;
      }
      else{
        return false;
      }
    },
    lookupSalesContact: function(){
      var contact = this.salesContactLookup[this.formData.vendorName.toLowerCase()];

      if(contact){
        this.salesContact.name = contact.name;
        this.salesContact.phone = contact.phone;
        this.salesContact.cell = contact.cell;
        this.salesContact.fax = contact.fax;
        this.salesContact.email = contact.email;
      }
      else if(this.formData['purchase_order__VENDOR__vendorID::salesContactNameFirst']){
        this.salesContact.name  = this.formData['purchase_order__VENDOR__vendorID::salesContactNameFirst'] + " " + this.formData['purchase_order__VENDOR__vendorID::salesContactNameLast'];
        this.salesContact.phone = this.formData['purchase_order__VENDOR__vendorID::salesContactPhone'];
        this.salesContact.cell  = this.formData['purchase_order__VENDOR__vendorID::salesContactCellPhone'];
        this.salesContact.fax   = this.formData['purchase_order__VENDOR__vendorID::salesContactFax'];
        this.salesContact.email = this.formData['purchase_order__VENDOR__vendorID::salesContactEmail'];
      }
      else{
        this.salesContact.name  = ""
        this.salesContact.phone = ""
        this.salesContact.cell  = ""
        this.salesContact.fax   = ""
        this.salesContact.email = ""
      }
      
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.input[disabled]{
    background-color: white;
    border-color: white;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #7a7a7a;
}
@media print {
  .column{
    width: 25%;
  }
  .columns{
   padding-left: 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/PurchaseOrder/PurchaseOrderForm.vue